var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
   'bb-notifications-bar-main-icon',
   _vm.item.notificationStatus && ("bb-notifications-bar-main-icon_" + (_vm.item.notificationStatus.class)),
   _vm.isReminder && 'bb-notifications-bar-main-icon_reminder',
   _vm.isBgRed && 'bb-notifications-bar-main-icon_background-red',
   _vm.isAcademy && 'bb-notifications-bar-main-icon_background-blue'
  ],domProps:{"innerHTML":_vm._s(_vm.getIcon)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6312cfb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/NotificationsBar/NotificationsBarMainIcon.vue
// module id = null
// module chunks = 